module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=BI - Burundi.518142c1.svg";